export default class BoilerObj {
    ratings = [
        // nizka    avg         velika
        [0.0999,	0.14985,	0.1998], // roke
        [0.2997,	0.34965,	0.3996], // higiena
        [0.3000,	0.41250,	0.5250], // posoda
        [0.9990,	1.33200,	1.6650] // tus
    ];

    del_leta = [365, 330, 210, 182, 30];

    hrnalinik_izguba = [
        // 30l  50l     80l     100l    120l
        [0.90,	1.32,	1.85,	2.20,	2.60], // klasika
        [0.55,	0.62,	0.86,	1.02,	1.17], // dobra
    ];

    static curr_use;
    static new_use
    static savings;
    static curr_price;
    static new_price;

    ukrep1;
    ukrep1_savings;
    new_rating;

    ukrep2;
    ukrep2_savings;

    ukrep3;
    ukrep3_savings;

    ukrep4;
    ukrep4_savings;

    ukrep5;
    ukrep5_savings;

    constructor(checked, del, clani, roke, higiena, posoda, tus, hranilnik, izolacija) {
        this.checked = checked;
        this.hranilnik = hranilnik;
        this.izolacija = izolacija;

        this.st_select = 6;
        this.short = "PGV";
        this.st_ukrepov = 0;

        this.del = this.del_leta[del];
        this.clani = clani;
        this.roke = roke;
        this.higiena = higiena;
        this.posoda = posoda;
        this.tus = tus;

        this.curr_use = this.del * clani * (this.ratings[0][roke - 1] + this.ratings[1][higiena - 1] + this.ratings[2][posoda - 1] + this.ratings[3][tus - 1]);

        if (checked == '1') {
            this.name = "Pretočni grelnik vode";
        } else {
            this.name = "Boiler";
            if (izolacija) {
                this.curr_use += this.hrnalinik_izguba[1][hranilnik - 1] * this.del;
            } else {
                this.curr_use += this.hrnalinik_izguba[2][hranilnik - 1] * this.del;
            }
        }
        

        
    }
}